export default __webpack_public_path__ + "static/media/wallet.f8d600ce.png";